import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

const locale = 'en-US'

export default new VueI18n({
  locale,
  messages: {
    'en-US': {
      general: {
        title: 'AHT ERC-20 Staking Page',
        eth: 'ETH',
        aht: 'AHT',
        erc20: 'ERC-20',
        ownRisk: 'USE AT YOUR OWN RISK',
        ahtVotes: 'AHT VOTES',
        amountStaked: 'Amount Staked',
        countdownUntilPayout: 'Countdown Until Payout',
        ahtRewardPool: 'Reward Pool',
        mustSteak: 'Must stake for min 72 hours to earn payout',
        connect: 'CONNECT TO WALLET',
        changeWallet: 'CHANGE WALLET',
        account: 'Account',
        change: 'Change',
        selectAccount: 'Select Account',
        ahtTokenAddress: 'AHT token address {address}',
        sending: 'Sending transaction',
        uniswap: 'Find AHT on Uniswap',
        intro: 'AHT Staking Intro',
        beta: 'BETA'
      },
      returnTokens: {
        yourTokensWillReturn: 'Your tokens will be returned on {date}'
      },
      stakingSystem: {
        title: 'Staking System',
        want: 'I want',
        ahtReward: 'AHT rewards',
        ethReward: 'ETH rewards',
        stake: 'Stake',
        send: 'Send',
        stop: 'Stop Staking',
        address: 'YOUR SMART CONTACT ADDRESS',
        note: 'Please note: you must send AHT ERC-20 takes from metamask only.',
        amountStaking: 'You are staking {amount} AHT',
        moreThanOneAHT: 'You need to have more than 1 AHT in your wallet',
        amountMoreThanZero: 'The amount to stake must be more than 0',
        notEnough: 'You don\'t have enough AHT',
        connectedToStake: 'You need to be connected to do stake',
        haveAHTToStake: 'You need to have AHT to do stake',
        stakeSuccessfully: 'Stake send successfully',
        copied: 'Copied'
      },
      popularVotes: {
        title: 'Community Voting',
        noItems: 'There aren\'t items to show',
        votingEnd: 'Voting ends in',
        timeLeft: '{days} days {hours} hours {minutes} minutes',
        for: 'Yes',
        against: 'No',
        voteFor: 'Votes For',
        voteAgainst: 'Votes Against',
        buildNext: 'What should we build next?'
      },
      stakingHistory: {
        communityStaking: 'Community Staking History',
        myStaking: 'My Staking History',
        address: 'ADDRESS',
        payoutType: 'PAYOUT TYPE',
        stakingLength: 'STAKING LENGTH',
        timeAgo: 'TIME AGO',
        reward: 'REWARD',
        pending: 'PENDING'
      }
    }
  }
})
